import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_NETWORKS_DATA, RESET_NETWORK_DATA } from 'modules/Services/types'

export const useNetworksData = (networkType) => {
  const dispatch = useDispatch()
  const { networks } = useSelector((state) => ({
    networks: state['services/list'].networks,
  }))

  useEffect(() => {
    dispatch({ type: FETCH_NETWORKS_DATA })

    return () => {
      dispatch({ type: RESET_NETWORK_DATA })
    }
  }, [])

  const { networkId, network } = useMemo(() => {
    const network = networks?.find((item) => item.type === networkType)

    return {
      network,
      networkId: network?.id,
    }
  }, [networks, networkType])

  return {
    networks,
    networkId,
    networkType,
    network,
  }
}
